import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'DELETE_FROM_OPER',
  title: 'Comment supprimer une entreprise d’une opération ?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Pour supprimer une entreprise d’une opération, vous pouvez effectuer votre demande au Service Clients en précisant le nom de l’opération, la dénomination sociale et le SIRET de l’entreprise à supprimer. '
  }]
};
